module.exports = __webpack_public_path__ + "22c0ae1bd79ded0f704f713a6b52c333.svg";